<ng-container *ngIf="userPinnedReports | async as reports">
   <ng-container *ngIf="reports.length">
      <button mat-icon-button [matMenuTriggerFor]="quickReportMenu" matTooltip="Quick Report">
         <mat-icon>timeline</mat-icon>
      </button>

      <mat-menu #quickReportMenu="matMenu" xPosition="before">
         <button mat-menu-item *ngFor="let report of reports; index as i" [routerLink]="[ '/report/run/', report.id ]">
            <mat-chip color="primary" *ngIf="badges && ( i < 9 )" class="scaled-chip">{{i + 1}}</mat-chip>
            {{report.name}}
         </button>
      </mat-menu>
   </ng-container>
</ng-container>